document.addEventListener('DOMContentLoaded', function() {
    /* 
    * GLOBAL
    */
    let menuBtn = document.querySelector('.header__button')
    if ( menuBtn ) {
        menuBtn.classList.add('visible')
        menuBtn.addEventListener('click', function() {
            if ( !this.classList.contains('active') ) {
                document.querySelector('.header__right').classList.remove('search-open')
                document.querySelector('.suggestion').classList.remove('active')
                document.querySelector('main').classList.add('hide')
                document.querySelector('body').style.overflow = 'hidden'
                menuBtn.classList.add('active')
                document.querySelector('.menu').classList.add('active')
            } else {
                document.querySelector('.header__right').classList.remove('search-open')
                document.querySelector('.suggestion').classList.remove('active')
                document.querySelector('main').classList.remove('hide')
                document.querySelector('body').style.overflow = ''
                menuBtn.classList.remove('active')
                document.querySelector('.menu').classList.remove('active')
            }
        })
    }

    document.querySelectorAll('.no-pointer').forEach(link => {
        link.classList.remove('no-pointer');
    });

    // Ativação da busca
    document.querySelectorAll('.header__search').forEach(function(searchButton) {
        searchButton.addEventListener('click', function () {
            document.querySelectorAll('.header__button.active, .menu.active').forEach(el => el.classList.remove('active'));
            document.querySelector('.header__right')?.classList.add('search-open');
            document.querySelector('.suggestion')?.classList.add('active');
            document.querySelector('main')?.classList.add('hide');
            document.body.style.overflow = 'hidden';
        });
    });

    // Fechamento da busca
    const searchClose = document.querySelector('.search__close');
    if (searchClose) {
        searchClose.addEventListener('click', function () {
            document.querySelectorAll('.header__button.active, .menu.active').forEach(el => el.classList.remove('active'));
            document.querySelector('.header__right')?.classList.remove('search-open');
            document.querySelector('.suggestion')?.classList.remove('active');
            document.querySelector('main')?.classList.remove('hide');
            document.body.style.overflow = '';
        });
    }

    // Reload após 5 minutos em páginas home ou category
    const body = document.body;
    if (body.classList.contains('home') || body.classList.contains('category')) {
        setTimeout(() => {
            location.reload(true);
        }, 300000);
    }

    // Toggle da edição
    document.querySelectorAll('.menu__edition').forEach(el => {
        el.addEventListener('click', function () {
            this.classList.toggle('active');
        });
    });

    wrapperDistance()
})

window.addEventListener('resize', function () {
    wrapperDistance()

})

// GLOBAL
function wrapperDistance() {
    const wrapper = document.querySelector('.wrapper');
    if (!wrapper) return;

    const distance = wrapper.getBoundingClientRect().left + window.pageXOffset;

    document.querySelectorAll('.wrapper-left').forEach(el => {
        el.style.paddingLeft = distance + 'px';
    });

    document.querySelectorAll('.wrapper-right').forEach(el => {
        el.style.paddingRight = distance + 'px';
    });
}

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// ------------------------------------------------
// Otimizações
function setupLazySlider(selector, initCallback, rootMargin = '200px') {
    const elements = document.querySelectorAll(selector);

    if (!elements.length) return;

    const initSlider = el => {
        if (!el.dataset.slickInitialized) {
            const $el = $(el);
            if (typeof $el.slick === 'function') {
                initCallback($el);
                el.dataset.slickInitialized = 'true';
            } else {
                setTimeout(() => initSlider(el), 100);
            }
        }
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initSlider(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { rootMargin });

    elements.forEach(el => {
        if (el.getBoundingClientRect().top < window.innerHeight) {
            initSlider(el);
        } else if ('idle' in window) {
            idle(() => observer.observe(el));
        } else {
            setTimeout(() => observer.observe(el), 200);
        }
    });
}

// ----------------
idle(() => {
    document.querySelectorAll('.menu__heading:not(.menu__item--newsletter)').forEach(heading => {
        heading.addEventListener('click', function () {
            const parent = heading.parentElement;
            const hasMenuList = heading.nextElementSibling?.classList.contains('menu__list');
    
            if (parent.classList.contains('active')) {
                parent.classList.remove('active');
            } else if (hasMenuList) {
                parent.classList.add('active');
            }
        });
    });
    
    document.querySelectorAll('.top').forEach(btn => {
        btn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
});